module.exports = __webpack_public_path__ + "static/media/reply-all.dcbea56c.svg";